module.exports = __webpack_public_path__ + "img/fashion_94.896f01c1.jpg";